export function getPageCategories(){
    return window.axios.get('user_page/get_categories').then((response) => {
        return response.data.data
    })
}
export function storeUserPage(pageData){
    return window.axios.post(`user_page/store`, pageData).then((response) => {
        return response.data.data
    })
}
export function getAllUserPages(page, keyword, category){
    return window.axios.get(`user_page/get_all?page=${page}&keyword=${keyword}&category=${category}`).then((response) => {
        return response.data.data
    }) 
}
export function getTrendingUserPages(page){
    return window.axios.get(`user_page/get_trending/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function getUserPagesForYou(page){
    return window.axios.get(`user_page/get_for_you/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function getMyUserPages(page){
    return window.axios.get(`user_page/get_my/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function searchMyUserPages(keyword, page){
    return window.axios.get(`user_page/search_my/${page}?query=${encodeURIComponent(keyword)}`).then((response) => {
        return response.data.data
    }) 
}
export function getFollowingPages(page){
    return window.axios.get(`user_page/get_following/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function switchPage(pageId){
    return window.axios.post(`user_page/switch_page`, {id: pageId}).then((response) => {
        return response.data.data
    })
}
export function loginBack(){
    return window.axios.post(`user_page/login_back`).then((response) => {
        return response.data.data
    })
}
export function storeDescriptionPage(descriptionData){
    return window.axios.post(`user_page/store_description`, descriptionData).then((response) => {
        return response.data.data
    })
}
export function storeAddressPage(addressData){
    return window.axios.post(`user_page/store_address`, addressData).then((response) => {
        return response.data.data
    })
}
export function storePhoneNumberPage(phoneNumber){
    return window.axios.post(`user_page/store_phone_number`, {phone_number: phoneNumber}).then((response) => {
        return response.data.data
    })
}
export function storeEmailPage(email){
    return window.axios.post(`user_page/store_email`, {email: email}).then((response) => {
        return response.data.data
    })
}
export function storePrivacyPage(type, value){
    return window.axios.post(`user_page/store_privacy`, {type: type, value: value}).then((response) => {
        return response.data.data
    })
}
export function getPriceRangePage(){
    return window.axios.get(`user_page/get_prices`).then((response) => {
        return response.data.data
    }) 
}
export function storePricePage(price){
    return window.axios.post(`user_page/store_price`, {price: price}).then((response) => {
        return response.data.data
    })
}
export function storeWebsitesPage(websites){
    return window.axios.post(`user_page/store_websites`, {websites: websites}).then((response) => {
        return response.data.data
    })
}
export function getOpenHoursPage(){
    return window.axios.get(`user_page/get_hours`).then((response) => {
        return response.data.data
    }) 
}
export function storeOpenHoursPage(type, values){
    return window.axios.post(`user_page/store_hour`,{type: type, values: values}).then((response) => {
        return response.data.data
    }) 
}
export function storeCategoriesPage(categoriesData){
    return window.axios.post(`user_page/store_category`, categoriesData).then((response) => {
        return response.data.data
    }) 
}
export function storeHashtagsPage(hashtagsData){
    return window.axios.post(`user_page/store_hashtag`, hashtagsData).then((response) => {
        return response.data.data
    }) 
}
export function storeProfilePage(settingData){
    return window.axios.post(`user_page/store_profile`, settingData).then((response) => {
        return response.data.data
    }) 
}
export function getAdminPage(page){
    return window.axios.get(`user_page/get_admin/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function storeAdminPage(adminData){
    return window.axios.post(`user_page/add_admin`, adminData).then((response) => {
        return response.data.data
    })  
}
export function removeAdminPage(userId){
    return window.axios.post(`user_page/remove_admin`, {id: userId}).then((response) => {
        return response.data.data
    }) 
}
export function storeReviewPage(reviewData){
    return window.axios.post(`user_page/store_review`, reviewData).then((response) => {
        return response.data.data
    }) 
}
export function getReviewsPage(pageId, page){
    return window.axios.get(`user_page/get_reviews/${pageId}/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function storeEnableReviewPage(enable){
    return window.axios.post(`user_page/store_enable_review`, {enable : enable}).then((response) => {
        return response.data.data
    }) 
}
export function getReportOverviewPage(){
    return window.axios.get(`user_page/get_report_overview`).then((response) => {
        return response.data.data
    }) 
}
export function getReportAudiencePage(){
    return window.axios.get(`user_page/get_report_audience`).then((response) => {
        return response.data.data
    }) 
}
export function getNotifySettingsPage(){
    return window.axios.get(`user_page/get_notify_setting`).then((response) => {
        return response.data.data
    }) 
}
export function storeNotifySettingsPage(dataSettings){
    return window.axios.post(`user_page/store_notify_setting`, dataSettings).then((response) => {
        return response.data.data
    }) 
}
export function transferPageOwner(ownerData){
    return window.axios.post(`user_page/transfer_owner`, ownerData).then((response) => {
        return response.data.data
    }) 
}
export function searchUsersForPageAdmin(keyword){
    return window.axios.get(`user_page/suggest_user_for_admin/${keyword}`).then((response) => {
        return response.data.data
    })
}
export function getSuggestUsersForTransfer(keyword){
    return window.axios.get(`user_page/suggest_user_for_transfer/${keyword}`).then((response) => {
        return response.data.data
    })
}
export function deletePageAccount(password){
    return window.axios.post('user_page/delete', password)
}
export function getFeaturePackages(){
    return window.axios.get('user_page/get_feature_packages').then((response) => {
        return response.data.data
    })
}
export function storeFeaturePage(packageData){
    return window.axios.post('user_page/store_feature', packageData).then((response) => {
        return response.data.data
    })
}
export function searchPagePosts(pageId, keyword, page){
    return window.axios.get(`user_page/search_post?query=${keyword}&id=${pageId}&page=${page}`).then((response) => {
        return response.data.data
    }) 
}
export function getPagePostsWithHashtag(pageId, hashtag, page){
    return window.axios.get(`user_page/get_post_with_hashtag/${pageId}/${hashtag}/${page}`).then((response) => {
        return response.data.data
    }) 
}
export function getPageMentions(pageId, page){
    return window.axios.get(`user_page/mentions?id=${pageId}&page=${page}`).then((response) => {
        return response.data.data
    })
}
export function getSitePagesPage(){
    return window.axios.get('user_page/get_site_pages').then((response) => {
        return response.data.data
    })
}
export function storeSitePage(data){
    return window.axios.post('user_page/store_site_page', data).then((response) => {
        return response.data.data
    })
}
export function deleteSitePage(id){
    return window.axios.post('user_page/delete_site_page', { id }).then((response) => {
        return response.data.data
    })
}
export function getSiteConfigPage(){
    return window.axios.get('user_page/get_site_config').then((response) => {
        return response.data.data
    })
}
export function storeSiteConfigPage(data){
    return window.axios.post('user_page/store_site_config', data).then((response) => {
        return response.data.data
    })
}
export function getPageCommerceOffers(page = 1){
    return window.axios.get(`user_page/commerce/get_my_offers/${page}`).then((response) => {
        return response.data.data
    })
}
export function storePageCommerceOffer(data){
    return window.axios.post('user_page/commerce/store_offer', data).then((response) => {
        return response.data.data
    })
}
export function deletePageCommerceOffer(id){
    return window.axios.post('user_page/commerce/delete_offer', { id }).then((response) => {
        return response.data.data
    })
}
export function getPageCommerceOrders(page = 1){
    return window.axios.get(`user_page/commerce/page_orders/${page}`).then((response) => {
        return response.data.data
    })
}
export function getPageCommerceBookings(page = 1){
    return window.axios.get(`user_page/commerce/page_bookings/${page}`).then((response) => {
        return response.data.data
    })
}
export function managePageCommerceBooking(data){
    return window.axios.post('user_page/commerce/manage_booking', data).then((response) => {
        return response.data.data
    })
}

function cmsGet(endpoint, params = {}){
    return window.axios.get(`user_page/cms/${endpoint}`, { params }).then((response) => response.data.data)
}

function cmsPost(endpoint, data = {}){
    return window.axios.post(`user_page/cms/${endpoint}`, data).then((response) => response.data.data)
}

export function getPageCmsOverview(){
    return cmsGet('overview')
}

export function getPageCmsMedia(params = {}){
    return cmsGet('media', params)
}

export function storePageCmsMediaFolder(data){
    return cmsPost('media/store_folder', data)
}

export function storePageCmsMediaAsset(data){
    return cmsPost('media/store_asset', data)
}

export function deletePageCmsMediaAsset(id){
    return cmsPost('media/delete_asset', { id })
}

export function trackPageCmsMediaUsage(id){
    return cmsPost('media/track_usage', { id })
}

export function getPageCmsBlocks(){
    return cmsGet('blocks')
}

export function storePageCmsBlock(data){
    return cmsPost('blocks/store', data)
}

export function getPageCmsTemplates(){
    return cmsGet('templates')
}

export function storePageCmsTemplate(data){
    return cmsPost('templates/store', data)
}

export function getPageCmsForms(){
    return cmsGet('forms')
}

export function storePageCmsForm(data){
    return cmsPost('forms/store', data)
}

export function deletePageCmsForm(id){
    return cmsPost('forms/delete', { id })
}

export function submitPageCmsForm(data){
    return cmsPost('forms/submit', data)
}

export function getPageCmsSubmissions(params = {}){
    return cmsGet('submissions', params)
}

export function storePageCmsSubmission(data){
    return cmsPost('submissions/store', data)
}

export function exportPageCmsSubmissions(params = {}){
    return cmsGet('submissions/export', params)
}

export function getPageCmsLeads(params = {}){
    return cmsGet('leads', params)
}

export function storePageCmsLead(data){
    return cmsPost('leads/store', data)
}

export function deletePageCmsLead(id){
    return cmsPost('leads/delete', { id })
}

export function addPageCmsLeadActivity(data){
    return cmsPost('leads/add_activity', data)
}

export function storePageCmsLeadTask(data){
    return cmsPost('leads/store_task', data)
}

export function getPageCmsTimeline(leadId){
    return cmsGet('leads/timeline', { lead_id: leadId })
}

export function getPageCmsResponseTemplates(){
    return cmsGet('response_templates')
}

export function storePageCmsResponseTemplate(data){
    return cmsPost('response_templates/store', data)
}

export function getPageCmsBookings(){
    return cmsGet('bookings')
}

export function storePageCmsBooking(data){
    return cmsPost('bookings/store', data)
}

export function deletePageCmsBooking(id){
    return cmsPost('bookings/delete', { id })
}

export function getPageCmsOrganizerEvents(){
    return cmsGet('organizer_events')
}

export function storePageCmsOrganizerEvent(data){
    return cmsPost('organizer_events/store', data)
}

export function deletePageCmsOrganizerEvent(id){
    return cmsPost('organizer_events/delete', { id })
}

export function getPageOrganizerEvents(userName){
    return window.axios.get(`user_page/events/${encodeURIComponent(userName)}`).then((response) => {
        return response.data.data
    })
}

export function getPageOrganizerEvent(userName, slug){
    return window.axios.get(`user_page/events/${encodeURIComponent(userName)}/${encodeURIComponent(slug)}`).then((response) => {
        return response.data.data
    })
}

export function getPageOrganizerEventRegistration(id){
    return window.axios.get(`user_page/events/${id}/registration`).then((response) => {
        return response.data.data
    })
}

export function joinPageOrganizerEvent(id, eventAnswers = {}){
    return window.axios.post(`user_page/events/${id}/join`, { event_answers: eventAnswers }).then((response) => {
        return response.data.data
    })
}

export function getPageCmsDocuments(){
    return cmsGet('documents')
}

export function storePageCmsDocument(data){
    return cmsPost('documents/store', data)
}

export function deletePageCmsDocument(id){
    return cmsPost('documents/delete', { id })
}

export function trackPageCmsDocumentAccess(id, meta = {}){
    return cmsPost('documents/track_access', { id, ...meta })
}

export function searchPageCms(query){
    return cmsGet('search', { query })
}

export function trackPageCmsEvent(data){
    return cmsPost('track_event', data)
}

export function getPageCmsConversionReports(days = 30){
    return cmsGet('conversion_reports', { days })
}

export function getPageCmsDashboardManager(){
    return cmsGet('dashboard_manager')
}

export function getPageCmsWorkflows(){
    return cmsGet('workflows')
}

export function storePageCmsWorkflow(data){
    return cmsPost('workflows/store', data)
}

export function createPageCmsPreviewToken(data){
    return cmsPost('preview_tokens/create', data)
}

export function verifyPageCmsPreviewToken(token){
    return cmsGet('preview_tokens/verify', { token })
}

export function getPageCmsScheduledJobs(){
    return cmsGet('scheduled_jobs')
}

export function storePageCmsScheduledJob(data){
    return cmsPost('scheduled_jobs/store', data)
}

export function runPageCmsDueScheduledJobs(){
    return cmsPost('scheduled_jobs/run_due', {})
}

export function getPageCmsModerationItems(){
    return cmsGet('moderation_items')
}

export function storePageCmsModerationItem(data){
    return cmsPost('moderation_items/store', data)
}

export function getPageCmsRedirects(){
    return cmsGet('redirects')
}

export function storePageCmsRedirect(data){
    return cmsPost('redirects/store', data)
}

export function getPageCmsBrokenLinks(){
    return cmsGet('broken_links')
}

export function storePageCmsBrokenLink(data){
    return cmsPost('broken_links/store', data)
}

export function scanPageCmsBrokenLinks(){
    return cmsPost('broken_links/scan', {})
}

export function getPageCmsRetentionRules(){
    return cmsGet('retention_rules')
}

export function storePageCmsRetentionRule(data){
    return cmsPost('retention_rules/store', data)
}

export function runPageCmsRetentionPurge(){
    return cmsPost('retention_rules/run_purge', {})
}

export function getPageCmsImportExports(){
    return cmsGet('import_exports')
}

export function exportPageCmsContent(data){
    return cmsPost('import_exports/export', data)
}

export function importPageCmsContent(data){
    return cmsPost('import_exports/import', data)
}

export function getPageCmsUploadScans(){
    return cmsGet('upload_scans')
}

export function scanPageCmsUpload(data){
    return cmsPost('upload_scans/scan', data)
}

export function getPageCmsJobHealth(){
    return cmsGet('job_health')
}

export function storePageCmsJobHealth(data){
    return cmsPost('job_health/store', data)
}

export function getPageCmsBlog(){
    return cmsGet('blog')
}

export function storePageCmsBlogPost(data){
    return cmsPost('blog/store_post', data)
}

export function deletePageCmsBlogPost(id){
    return cmsPost('blog/delete_post', { id })
}

export function storePageCmsBlogTaxonomy(data){
    return cmsPost('blog/store_taxonomy', data)
}

export function storePageCmsBlogComment(data){
    return cmsPost('blog/store_comment', data)
}

export function getPageCmsContactLegal(){
    return cmsGet('contact_legal')
}

export function storePageCmsContactSettings(data){
    return cmsPost('contact_legal/store_contact', data)
}

export function storePageCmsCompanyProfile(data){
    return cmsPost('contact_legal/store_company', data)
}

export function getPageCmsMenus(){
    return cmsGet('menus')
}

export function storePageCmsMenu(data){
    return cmsPost('menus/store', data)
}

export function storePageCmsMenuItem(data){
    return cmsPost('menus/store_item', data)
}

export function getPageCmsSeo(){
    return cmsGet('seo')
}

export function storePageCmsSeoMeta(data){
    return cmsPost('seo/store_meta', data)
}

export function rebuildPageCmsSitemap(){
    return cmsPost('seo/rebuild_sitemap', {})
}

export function getPageCmsBackups(){
    return cmsGet('backups')
}

export function createPageCmsBackup(data = {}){
    return cmsPost('backups/create', data)
}

export function restorePageCmsBackup(id){
    return cmsPost('backups/restore', { id })
}

export function getPageCmsDesignRules(){
    return cmsGet('design_rules')
}

export function storePageCmsDesignRules(data){
    return cmsPost('design_rules/store', data)
}

export function getPageCmsSettings(){
    return cmsGet('settings')
}

export function storePageCmsSettings(data){
    return cmsPost('settings/store', data)
}

export function savePageCmsPageVersion(data){
    return cmsPost('pages/save_version', data)
}

export function getPageCmsPagesList(){
    return cmsGet('pages/list')
}

export function getPageCmsPageVersions(sitePageId){
    return cmsGet('pages/versions', { site_page_id: sitePageId })
}

export function restorePageCmsPageVersion(data){
    return cmsPost('pages/restore_version', data)
}

export function getPageCmsMediaVariants(assetId){
    return cmsGet('media/variants', { asset_id: assetId })
}

export function storePageCmsMediaVariant(data){
    return cmsPost('media/store_variant', data)
}

export function getPageCmsSchemaMarkup(){
    return cmsGet('schema_markup')
}

export function storePageCmsSchemaMarkup(data){
    return cmsPost('schema_markup/store', data)
}

export function getPageCmsAuditLogs(limit = 100){
    return cmsGet('audit_logs', { limit })
}
